import React from 'react';
export function Bonos() {
  const bonos = [{
    num: '01',
    title: 'Biblioteca de Guiones Virales "Misión Influencia Pro"',
    desc: 'Scripts adicionales listos para usar en cualquier formato de contenido.',
    oldPrice: '$12.000'
  }, {
    num: '02',
    title: 'Pack Premium de Diseño "Canva del Reino"',
    desc: '100 plantillas editables en Canva para que tu cuenta se vea premium desde hoy.',
    oldPrice: '$15.000'
  }, {
    num: '03',
    title: 'Sistema de DMs "Conversaciones que Transforman"',
    desc: '50 scripts para responder, profundizar y acompañar conversaciones reales por mensaje directo.',
    oldPrice: '$12.000'
  }, {
    num: '04',
    title: 'Planificador Anual "365 Días de Contenido con Propósito"',
    desc: '52 semanas de temas, ideas y formatos para nunca más quedarte en blanco.',
    oldPrice: '$14.000'
  }, {
    num: '05',
    title: 'Auditoría de Cuenta "Misión Influencia"',
    desc: 'Diagnóstico personalizado de tu perfil con plan correctivo por prioridad.',
    oldPrice: '$18.000'
  }];
  return <section className="py-[60px] px-5 bg-goldTint border-y border-gold" data-id="element-18">
      <div className="max-w-[760px] mx-auto" data-id="element-19">
        <p className="text-center text-[13px] tracking-[3px] text-gold font-bold mb-2" data-id="element-20">
          🎁 5 BONOS — SIEMPRE INCLUIDOS
        </p>
        <h2 className="text-[22px] md:text-[34px] font-black text-center mb-3 text-text-heading" data-id="element-21">
          Todo lo que necesitás para arrancar{' '}
          <span className="text-gold" data-id="element-22">desde hoy</span>
        </h2>

        <div className="grid grid-cols-1 gap-4 mt-6" data-id="element-23">
          {bonos.map((bono, i) => <div key={i} className="bg-card border border-cardBorder rounded-xl p-5 sm:p-6 flex flex-col sm:flex-row items-start gap-4 hover:border-gold/50 transition-colors" data-id="element-24">
              <div className="bg-gold-gradient text-base font-black text-[13px] min-w-[36px] h-[36px] rounded-full flex items-center justify-center shrink-0" data-id="element-25">
                {bono.num}
              </div>
              <div className="flex-1" data-id="element-26">
                <p className="text-[15px] font-extrabold text-white mb-1.5" data-id="element-27">
                  {bono.title}
                </p>
                <p className="text-[13px] text-text-muted leading-relaxed mb-2" data-id="element-28">
                  {bono.desc}
                </p>
                <p className="text-[13px]" data-id="element-29">
                  <s className="text-[#666]" data-id="element-30">{bono.oldPrice}</s>
                  <strong className="text-gold ml-2" data-id="element-31">→ GRATIS</strong>
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-6 text-base text-white font-bold" data-id="element-32">
          VALOR TOTAL DE BONOS: <s className="text-[#666]" data-id="element-33">$71.000</s>{' '}
          <span className="text-gold text-xl" data-id="element-34">→ GRATIS</span> con tu Misión
          Influencia
        </div>
      </div>
    </section>;
}